
<template>
  <div class="page home">

    <div class="header">
      <img src="@/assets/logo-cahm-definitif-sans-baseline.png" />
    </div>

    <div class="welcome">

      <div class="title"> 
        <h1>Le Bois<br/>de Riquet</h1>
        <h5 class="formation">Découvrez l'histoire de la formation<br> géologique du Bois de Riquet</h5><br>
      </div>


      <div class="cta">
        <router-link to="/Tutorial" class="buttonLink">Commencez</router-link>
        <p class="buttonLink" @click="install" v-if="prompt">Installer l'app</p>
      </div>

    </div>

  </div>
</template>

<script>

export default {
  name: 'home',
  components: {},
  data: () => ({
    prompt: null,
    skip_resume_app: true
  }),
  mounted: function() {
    window.addEventListener('beforeinstallprompt', e => {
      console.log('before prompt fired');

      this.prompt = e;

      e.preventDefault();
    });

    var saved_data = window.localStorage.getItem("target");

    if (saved_data && !this.skip_resume_app)
      return this.$router.push({name: "Geolocation", params: {place: saved_data}});
  },
  methods: {
    install: function() {
      var prompt = this.prompt;
      this.prompt = null;
      console.log('install !');

      prompt.prompt();
      prompt.userChoice.then((result) => {
        console.log('install prompt succeed !');
      })

    }
  }
}

	
  
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

  .home {

    display: flex;
    flex-direction: column;

    .header {
      @media screen and (min-width: 500px) {
        margin-top: 20px;
        max-width: 350px;

        img {
          object-fit: contain;
        }
      }

    }

    .welcome {

      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      height: 100%;

      .title {
        margin-bottom: 0;
        margin: 0px auto;
        width: 90%;

        @media screen and (min-width: 500px) {
          width: 300px;
        }

        h1 {
          font-size: 3em;
          border-bottom: solid 2px #ED3B24;
          text-align: center;
          font-family: "Yeseva One",cursive;
          font-weight: 400;
          color: #000;
          margin: 0;
          padding-bottom: 20px;
          margin-bottom: 10px;
        }

      }

      .formation {
        margin: 0;
        text-align: right;
        font-weight: 400;
        color: #ED3B24;
      }

      p {
        display: flex;
        text-align: right;
        line-height: 100%;
        justify-content: right;
      }

    }

    .cta {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue